export const MAX_HEIGHT = 100;
export const FADE_OUT_HEIGHT = 50;
